<div class="card p-0 animate__animated animate__fadeIn">
  <div class="logo-auth">
    <img src="../../../assets/images/logo-auth.png" alt="" />
  </div>
  <div class="p-4">
    <h2 class="text-center mb-4 inter-Regular">Forgot Password</h2>
    <form #frm="ngForm" (submit)="frm.form.valid && onSubmit(frm)">
      <div class="mb-3">
        <label for="email" class="form-label">Email address</label>
        <input
          type="email"
          class="form-control"
          name="email"
          ngModel
          #email="ngModel"
          required
          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
          trimTextInput
        />
        @if(frm.submitted && email.invalid) { @if(email.hasError('required')) {
        <span class="m-0 text-danger">Email is required.</span>
        } @if(email.hasError('pattern')) {
        <span class="m-0 text-danger">Invalid email address</span>
        } }
      </div>
      <div class="mb-4">
        <!-- <button type="submit" class="btn btn-llink float-start rounded-pill w-150px">Cancel</button> -->
        <a
          routerLink="/login"
          class="me-2 btn btn-outline-light float-start rounded-pill w-150px"
        >
          Cancel
        </a>
        <button
          type="submit"
          class="btn btn-warning rounded-pill text-white w-150px float-end"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
